﻿import { defineComponent } from 'vue';

import { product_detail } from '../../../objects/v1_3/product/product/product_detail';
import { room_passengers } from '../../../objects/front_end/room/room_passengers';
import { room_passengers_type } from '../../../objects/front_end/room/room_passengers_type';

import { product_detail_seller_information } from '../../../objects/v1_3/product/product/product_detail_seller_information';
import { product_detail_seller_information_room } from '../../../objects/v1_3/product/product/product_detail_seller_information_room';

import { Booking } from "../../../services/booking";
import { Room } from "../../../services/room";
import { Product } from '../../../services/product';

import { Currency_Service } from "../../../../system/services/currency";
import { room } from '../../../objects/v1_2/Booking/Room';
import { stringifyQuery } from 'vue-router';

const Book = new Booking()
const Prod = new Product();
const Service_Room = new Room();
const Currency_Services = new Currency_Service();

export default defineComponent({
    name: "sales_group_room_type",
    props: {
        tour_id: String,
        year: Number,
        month: Number,
        trip_index: Number
    },
    data() {
        return {
            product: new product_detail(),
            room_selected: null as string | null,
            currentRoomInfo: null as string | null
        }
    },
    methods: {
        get_Rooms(): product_detail_seller_information_room[] {
            if (this.product == undefined) {
                return [];
            }

            if (this.product.seller_information == undefined) {
                return [];
            }

            return this.product.seller_information.rooms;
        },
        order_Rooms_by_available(rooms: room_passengers_type[]): room_passengers_type [] {
            let available_rooms: room_passengers_type[] = [];
            let not_available_rooms: room_passengers_type[] = [];

            rooms.forEach(room => {
                if (this.get_Room_Available(room)) {
                    available_rooms.push(room);
                } else {
                    not_available_rooms.push(room);
                }
            });

            not_available_rooms.forEach(room => {
                available_rooms.push(room);
            });

            return available_rooms;
        },
        get_Room_List(): room_passengers_type[] {
            return Service_Room.get_Room_List(this.product, this.$store);
        },
        async get_Product() : Promise<void> {
            this.product = await Prod.Get_Details(this.tour_id ?? "", this.$store);
        },
        async select_room_type(room: room_passengers_type) {
            this.room_selected = room.name;

            this.$store.commit("Initialise_Booking_Room_Type", { Trip_Index: this.get_Trip_Index(), Room_Type: room });
            await Book.Setup_Booking(this.$store);
        },
        is_Selected(room: room_passengers_type): boolean {
            //the basket's rooms are cleared when the passengers change, the option is then no longer selected
            return this.room_selected == room.name && this.$store.getters.get_Basket?.trips[this.get_Trip_Index()]?.rooms?.length > 0;
        },
        get_Price(room: room_passengers_type): string {
            //room option price on top of the base price, using the selected departure date's prices or the month's prices until a date is chosen
            let Base_Price: number = Service_Room.get_Base_Price(this.product, this.get_Trip_Index(), this.$store);
            let Room_Price: number = Service_Room.get_Capacity_Room_Price(this.product, room, this.get_Trip_Index(), this.$store);

            if (Base_Price <= 0) {
                Base_Price = Service_Room.get_Month_Base_Price(this.product, this.year ?? 0, this.month ?? 0, this.$store);
                Room_Price = this.get_Sales_Price(room);
            }

            if (Base_Price <= 0 || Room_Price <= 0 || Room_Price == Base_Price) {
                return "";
            }

            let Difference: number = Room_Price - Base_Price;
            let return_price_string = Currency_Services.Format_Currency(Difference, this.$store.getters.get_Currency);

            return (Difference < 0) ? return_price_string : "+ " + return_price_string;
        },
        get_Sales_Price(room: room_passengers_type): number {
            return Service_Room.get_Sales_Price(this.product, room, this.year ?? 0, this.month ?? 0, this.$store);
        },
        get_ID(room: product_detail_seller_information_room): string {
            return this.tour_id + "-" + room.name.replace(" ", "");
        },
        get_Room_Capacity(room: room_passengers_type): string {
            return Service_Room.get_Room_Capacity(room, this.$store) + "--" + String(Service_Room.get_Room_Capacity_Available(room, this.$store));
        },
        Exclude_Child_from_dorms(): boolean {
            return import.meta.env.VITE_EXCLUDE_CHILDREN_FROM_DORMS == "true" ;
        },
        get_Room_Available(room: room_passengers_type): boolean {
            let Capacity_Available = Service_Room.get_Room_Capacity_Available(room, this.$store)
                && Service_Room.has_Room_Price(this.product, room, this.year ?? 0, this.month ?? 0, this.get_Trip_Index(), this.$store);

            if(this.Exclude_Child_from_dorms() && (room.name?.toLowerCase().includes("dorm") || room.name?.toLowerCase().includes("private")))
            {
                if(this.$store.getters.get_Basket.passengers.length > 0){
                    this.$store.getters.get_Basket.passengers.forEach((passenger: { age_category: string }) => {
                        if (passenger.age_category.toLowerCase().includes("child")) {
                            Capacity_Available = false;
                        }
                    });
                }
            }

            if(this.is_Selected(room) && !Capacity_Available){
                this.clearRoomSelected();
            }
            return Capacity_Available;
        },
        clearRoomSelected(){
            let null_room: room_passengers_type = new room_passengers_type();
            this.select_room_type(null_room);
        },
        get_Trip_Index(): number {
            return this.trip_index ?? 0;
        },
        get_room_description(room: string): string {

            let output: string ="";
            if(room.toLowerCase().includes("private quad room")){
                output+= "Private Quad Room: Private hostel room, suitable for 4 people.\n";
            }
            
            if(room.toLowerCase().includes("private triple room")){
                output+= "Private Triple Room: Private hostel room, suitable for 3 people.\n";
            }
            
            if(room.toLowerCase().includes("private twin room")){
                output+= "Private Twin Room: Private hostel room, suitable for 2 people\n";
            } 
            else if(room.toLowerCase().includes("twin room")){
                output+= "Twin Room: 1 room with 2 single beds. Suitable for 2 people, one bed each.\n";
            }
            
            if(room.toLowerCase().includes("double room")){
                output+= "Double Room: 1 room with 1 double bed. Suitable for 2 people to share\n";
            }
            
            if(room.toLowerCase().includes("1 single")){
                output+= "Single Room: 1 room with 1 single bed. Suitable for 1 person. There will be a single occupancy supplement\n";
            }
            
            if(room.toLowerCase().includes("2 single")){
                output+= "2 Single Rooms: 2 rooms with 1 single bed. Suitable for 2 people.\n";
            }
            
            if(room.toLowerCase().includes("family 3 room")){
                output+= "Family 3 Room: 1 room with 1 double bed and 1 single bed. Suitable for 3 people.\n";
            }
            
            if(room.toLowerCase().includes("family 4 room")){
                output+= "Family 4 Room: 1 room with 1 double bed and 2 single beds. Suitable for 4 people.\n";
            
            }
            if(room.toLowerCase().includes("dorm bed")){
                output+= "Dorm Bed: 1 mixed-gender hostel room shared with multiple travellers, one bed each. \n";
            }
            
            return output;
        },
        setShowInfo(room: string){
            if(this.currentRoomInfo == room){
                this.currentRoomInfo = null;
            }
            else{
                this.currentRoomInfo = room;
            }
        }
    },
    mounted() {
        this.get_Product()
    }
})